var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchFilter = function SvgSearchFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.5 2.389a.89.89 0 0 1 .889-.889H16.61a.89.89 0 0 1 .889.889v2.299a.9.9 0 0 1-.26.628l-5.702 5.701a.9.9 0 0 0-.26.629v2.298L7.722 17.5v-5.854a.9.9 0 0 0-.26-.629L1.76 5.316a.9.9 0 0 1-.26-.628z"
  })));
};
export default SvgSearchFilter;